import { atom } from 'jotai';
import { isInHaiti } from '../utils/locationUtils';

interface Coordinates {
  lat: number;
  lng: number;
}

export const userLocationAtom = atom<Coordinates | null>(null);
export const locationAccuracyAtom = atom<number | null>(null);
export const isHighAccuracyAtom = atom<boolean>(false);
export const locationErrorAtom = atom<GeolocationPositionError | null>(null);
export const locationPermissionAtom = atom<PermissionState | null>(null);
export const locationZoneAtom = atom<string>('');

// Derived atom to track if user is in Haiti
export const isUserInHaitiAtom = atom<boolean | null>(get => {
  const userLocation = get(userLocationAtom);
  if (!userLocation) return null;
  return isInHaiti(userLocation.lat, userLocation.lng);
});